<!--FILTRO-->
<div class="cont-filtro-maquinas-areas clearfix">
  <!-- FILTRO GRUPOS -->
  <div class="filtro-areaproductiva-cont" style="width: 230px;">
    <div class="card" style="height: 90px;">
      <div class="card-body">
        <div class="row">
          <!--AREAS PRODUCTIVAS-->
          <div class="col-md-12" style="margin-top: -3px;">
            <kendo-multiselect kendoMultiSelectSummaryTag [(data)]="groupedSeccion"
                               [textField]="'nombre'"
                               [valueField]="'id'"
                               [autoClose]="false"
                               (close)="filtrarMaquinasPorAreaProductivaYGrupo(false)"
                               [(ngModel)]="seccionesSeleccionadas"
                               placeholder="{{ 'secciones' | translate }}"
                               style="width: 200px;"
                               [kendoDropDownFilter]="{operator: 'contains'}">
              <ng-template kendoMultiSelectGroupTagTemplate let-dataItems>
                <span class="k-icon k-i-arrow-s"></span>
                <ng-container *ngIf="dataItems.length == 1">{{ dataItems[0].nombre }}</ng-container>
                <ng-container *ngIf="dataItems.length > 1">{{ dataItems.length }} {{ 'seccionesSeleccionadas' | translate }}</ng-container>
              </ng-template>
              <kendo-multiselect-messages noDataText="{{'norecords' | translate}}"></kendo-multiselect-messages>
            </kendo-multiselect>
          </div>
          <!--GRUPOS-->
          <div class="col-md-12" style="margin-top: 3px;">
            <kendo-multiselect kendoMultiSelectSummaryTag [data]="grupos"
                               [textField]="'nombre'"
                               [valueField]="'id'"
                               [autoClose]="false"
                               (close)="filtrarMaquinasPorAreaProductivaYGrupo(false)"
                               [(ngModel)]="gruposSeleccionados"
                               placeholder="{{ 'grupoMaquinas' | translate }}"
                               style="width: 200px;"
                               [kendoDropDownFilter]="{operator: 'contains'}">
              <ng-template kendoMultiSelectGroupTagTemplate let-dataItems>
                <span class="k-icon k-i-arrow-s"></span>
                <ng-container *ngIf="dataItems.length == 1">{{ dataItems[0].nombre }}</ng-container>
                <ng-container *ngIf="dataItems.length > 1">{{ dataItems.length }} {{ 'gruposSeleccionados' | translate }}</ng-container>
              </ng-template>
            </kendo-multiselect>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- MAQUINAS -->
  <div class="cont-select-maquinas-out" [ngClass]="{'aparecer': aparecer == true}">
    <div class="desplegar-selector-maquina" (click)="desplegarMaquinasClick()">
      <i class="fas fa-ellipsis-v"></i>
    </div>
    <div class="cont-select-maquinas" [ngClass]="{'h-90': aparecer == false}">
      <div *ngFor="let maquina of maquinasMostradas" (click)="recargarPagina(maquina);" class="clickable" [ngClass]="{'actual': maquina.id==selectedMaquina}">
        <label>{{maquina.nombre}}</label>
        <img class="fas fa-3x" [src]="maquina.imagenBase64">
      </div>
    </div>
  </div>
  <!-- FILTRO TURNOS Y FECHAS -->
  <div class="card cont-filtro-informes">
    <div class="card-body">
      <!--Turnos-->
      <div class="form-group">
        <label ID="lAsignarPerdidaA" class="control-label">{{ 'turno' | translate }}</label>
        <div class="caja" [formGroup]="form">
          <kendo-multiselect [(value)]="comboTurnosSeleccion" [placeholder]="turnos_placeHolder" [data]="turnosCombo" [textField]="'nombre'" [valueField]="'id'"
                             (valueChange)="turnos_onValueChange($event)" [kendoDropDownFilter]="{operator: 'contains'}"></kendo-multiselect>
        </div>
      </div>
      <!--Fechas-->
      <div class="form-group">
        <label ID="lAsignarPerdidaA" class="control-label">{{ 'fechas' | translate }}</label>
        <div class="caja">
          <!-- <kendo-datepicker class="filtro-informes-data-1" [(value)]="fechaInicio" (valueChange)="fechaInicio_dateChanged($event)">
            <kendo-calendar-messages today="{{ 'hoy' | translate }}">
            </kendo-calendar-messages>
          </kendo-datepicker>
          <kendo-datepicker class="filtro-informes-data-2" [(value)]="fechaFin" (valueChange)="fechaFin_dateChanged($event)">
            <kendo-calendar-messages today="{{ 'hoy' | translate }}">
            </kendo-calendar-messages>
          </kendo-datepicker> -->






          <!-- CONTROL -->
          <div class="calendarFiltro-input" (click)="showCalendar()">
            <label *ngIf="fechaInicio != undefined && fechaFin == undefined">{{fechaInicio | kendoDate}}</label>
            <label *ngIf="fechaFin != undefined && fechaFin != undefined">{{fechaInicio | kendoDate}} - {{fechaFin | kendoDate}}</label>
            <i class="k-icon k-i-calendar"></i>
          </div>
          <!-- CONTROL EXPANDIDO -->
          <div class="calendarFiltro-calendario" style="position: absolute !important; width: 367px;" [ngClass]="mostrarCalendario ? 'mostrarCalendario' : 'ocultarCalendario'">
            <div class="row">
              <div class="col-mes">
                <kendo-calendar id="calendario-0" [(value)]="DaysInMonths[0]" type="classic" (click)="valueClickCalendar(0, $event)">
                  <ng-template kendoCalendarMonthCellTemplate let-date>
                    <span class="calendarFiltro-calendario-contenido-dia" [class.calendarFiltro-calendarioSeleccionado]="isDateSelected(date)"> {{ date.getDate() }} </span>
                  </ng-template>
                  <ng-template kendoCalendarHeaderTitleTemplate let-title>
                    <div> {{ title }} </div>
                  </ng-template>
                </kendo-calendar>
              </div>
              <div class="col-mes-botones">
                <div class="calendarFiltro-botones">
                  <div class="clearfix text-center">
                    <button (click)="cambiarMeses(-1)"><i class="fa fa-chevron-left"></i></button>
                    <button (click)="cambiarMeses(1)"><i class="fa fa-chevron-right"></i></button>
                    <button (click)="cargarMeses()">{{ 'hoy' | translate}}</button>
                  </div>
                  <div class="pl-2">
                    <div class="clearfix"><button (click)="ultimas24HButton()">{{'ultimas24H' | translate}}</button></div>
                    <div class="clearfix"><button (click)="ultimos7DiasButton()">{{'ultimos7Dias' | translate}}</button></div>
                    <div class="clearfix"><button (click)="ultimos30DiasButton()">{{'ultimos30Dias' | translate}}</button></div>
                    <!-- <div class="clearfix"><button (click)="ultimos60DiasButton()">{{'ultimos60Dias' | translate}}</button></div>
                                <div class="clearfix"><button (click)="ultimos90DiasButton()">{{'ultimos90Dias' | translate}}</button></div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>



        </div>
      </div>
    </div>
  </div>
</div>

<!--GRAFICOS-->
<!--LINEA 1-->
<div class="clearfix">
  <div class="card">
    <div id="chartGanttTimeline" style="min-height:100px;"></div>
    <div *ngIf="loadingGantt" class="k-i-loading"></div>
  </div>
</div>

<!--LINEA 2.1-->
<div class="row">
  <!--Resumen Semana-->
  <div class="col-md-4">
    <div class="card">
      <div class="card-header">
        <h3>
          <label ID="lResumenSemana_Estados" CssClass="">{{ 'resumen' | translate }}</label>
        </h3>
        <div class="plegarpanel"></div>
      </div>
      <div class="card-body">
        <div class="row" [ngClass]="{'d-none': this.sinEstados}" id="chartDonutResumenSemana_Estados"></div>
        <div class="clearfix cont-donut-vacio" *ngIf="sinEstados" style="height: 300px;position: relative;display: flex;align-items: center;">
          <img class="float-left" src="../../../assets/img/donut-vacio.png" style="height: auto; margin: 0 auto; width: 60%; max-width: 275px;" />
          <div>
            <label class="sindatos">{{ 'sinDatos' | translate}}</label>
          </div>
        </div>
      </div>
      <div *ngIf="loadingResumenSemana_Estados" class="k-i-loading"></div>
    </div>
  </div>
  <!--Horas Dia-->
  <!-- <div class="col-md-8 d-none">
    <div class="card">
      <div class="card-header">
        <h3>
          <label ID="lHorasDia_Estados" CssClass="">{{ 'horasDia' | translate }}</label>
        </h3>
        <div class="plegarpanel"></div>
      </div>
      <div class="card-body">
        <div id="chartAreaHorasDia_Estados"></div>
      </div>
      <div *ngIf="loadingHorasDia_Estados" class="k-i-loading"></div>
    </div>
  </div> -->
  <!--Turnos-->
  <div class="col-md-8">
    <div class="card">
      <div class="card-header">
        <h3>
          <label *ngIf="!this.sinPiezasTurnos || this.sinEstados" CssClass="">{{ 'piezasTurno' | translate }}</label>
          <label *ngIf="this.sinPiezasTurnos && !this.sinEstados" CssClass="">{{ 'horasDia' | translate }}</label>
        </h3>
        <div class="plegarpanel"></div>
      </div>
      <div [ngClass]="{'d-none': this.sinPiezasTurnos && this.sinEstados}" class="card-body">
        <div [ngClass]="{'d-none': this.sinPiezasTurnos}">
          <div class="row bloques-turnos-graf">
            <!-- HORAS / PIEZAS-->
            <div class="con-selector-horaspiezas">
              <div class="btn" [class.btn-success]="mostrarEnHoras" [class.btn-outline-success]="!mostrarEnHoras">
                <input type="radio" name="horasPiezasGroup" id="btnHoras" class="k-radio" (click)="clickHorasPiezas(true)" [checked]="mostrarEnHoras" kendoRadioButton>
                <label class="k-radio-label" for="btnHoras">{{ 'tEstimado' | translate }}</label>
              </div>
              <div class="btn" [class.btn-success]="!mostrarEnHoras" [class.btn-outline-success]="mostrarEnHoras">
                <input type="radio" name="horasPiezasGroup" id="btnPiezas" class="k-radio" (click)="clickHorasPiezas(false)" [checked]="!mostrarEnHoras" kendoRadioButton>
                <label class="k-radio-label" for="btnPiezas">{{ 'piezas' | translate }}</label>
              </div>
            </div>
            <!-- TIPO: MANUAL / AUTOMATICO / AUTOCORREGIDO-->
            <div class="con-selector-horaspiezas">
              <div class="btn" [class.btn-success]="mostrarContadorTipo == 1" [class.btn-outline-success]="mostrarContadorTipo != 1">
                <input type="radio" name="tipoPiezasGroup" id="btnManual" class="k-radio" (click)="clickTipoPiezas(1)" [checked]="mostrarContadorTipo == 1" kendoRadioButton>
                <label class="k-radio-label" for="btnManual">{{ 'manual' | translate }}</label>
              </div>
              <div class="btn" [class.btn-success]="mostrarContadorTipo == 2" [class.btn-outline-success]="mostrarContadorTipo != 2">
                <input type="radio" name="tipoPiezasGroup" id="btnAutomatico" class="k-radio" (click)="clickTipoPiezas(2)" [checked]="mostrarContadorTipo == 2" kendoRadioButton>
                <label class="k-radio-label" for="btnAutomatico">{{ 'automatico' | translate }}</label>
              </div>
              <!-- <div class="btn" [class.btn-success]="mostrarContadorTipo == 3" [class.btn-outline-success]="mostrarContadorTipo != 3">
                <input type="radio" name="tipoPiezasGroup" id="btnAutocorregido" class="k-radio" (click)="clickTipoPiezas(3)" [checked]="mostrarContadorTipo == 3" kendoRadioButton>
                <label class="k-radio-label" for="btnAutocorregido">{{ 'autocorregido' | translate }}</label>
              </div> -->
            </div>
            <!-- ACCION MALAS: ATRASAR / ADELANTAR -->
            <div class="con-selector-horaspiezas d-none">
              <div class="btn" [class.btn-success]="mostrarContadorAccion == 1" [class.btn-outline-success]="mostrarContadorAccion != 1">
                <input type="radio" name="accionPiezasGroup" id="btnAtrasar" class="k-radio" (click)="clickAccionPiezas(1)" [checked]="mostrarContadorAccion == 1" kendoRadioButton>
                <label class="k-radio-label" for="btnAtrasar">{{ '->' | translate }}</label>
              </div>
              <div class="btn" [class.btn-success]="mostrarContadorAccion == 2" [class.btn-outline-success]="mostrarContadorAccion != 2">
                <input type="radio" name="accionPiezasGroup" id="btnAdelantar" class="k-radio" (click)="clickAccionPiezas(2)" [checked]="mostrarContadorAccion == 2" kendoRadioButton>
                <label class="k-radio-label" for="btnAdelantar">{{ '<-' | translate }}</label>
              </div>
            </div>
            <!-- REPARTIR MALAS: SI (AGRUPAR) / NO (REPARTIR) -->
            <!-- <div class="con-selector-horaspiezas">
              <div class="btn" [class.btn-success]="mostrarContadorRepartir == 1" [class.btn-outline-success]="mostrarContadorRepartir != 1">
                <input type="radio" name="repartirPiezasGroup" id="btnAgrupar" class="k-radio" (click)="clickRepartirPiezas(1)" [checked]="mostrarContadorRepartir == 1" kendoRadioButton>
                <label class="k-radio-label" for="btnAgrupar">{{ '-xx-' | translate }}</label>
              </div>
              <div class="btn" [class.btn-success]="mostrarContadorRepartir == 2" [class.btn-outline-success]="mostrarContadorRepartir != 2">
                <input type="radio" name="repartirPiezasGroup" id="btnRepartir" class="k-radio" (click)="clickRepartirPiezas(2)" [checked]="mostrarContadorRepartir == 2" kendoRadioButton>
                <label class="k-radio-label" for="btnRepartir">{{ 'x--x' | translate }}</label>
              </div>
            </div>  -->

            <div class="bloques-turnos">
              <!-- MAÑANA -->
              <div class="mannana bloque-turno celda-tooltip-externo order-2">
                <div class="inner-bloques-turnos tooltip-consumibles-contenido">
                  <div class="cont-icono">

                    <div class="cont-icono-circular">

                      <svg width="25" height="27" viewBox="0 0 25 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.1361 16.8426C13.0993 16.8426 13.918 16.4807 14.5923 15.7569C15.2665 15.0332 15.6036 14.1543 15.6036 13.1204C15.6036 12.0864 15.2665 11.2076 14.5923 10.4838C13.918 9.76003 13.0993 9.39815 12.1361 9.39815C11.173 9.39815 10.3542 9.76003 9.68002 10.4838C9.00579 11.2076 8.66867 12.0864 8.66867 13.1204C8.66867 14.1543 9.00579 15.0332 9.68002 15.7569C10.3542 16.4807 11.173 16.8426 12.1361 16.8426ZM12.1361 18.0833C10.8484 18.0833 9.75597 17.6017 8.85872 16.6386C7.96147 15.6754 7.51285 14.5027 7.51285 13.1204C7.51285 11.7381 7.96147 10.5653 8.85872 9.60216C9.75597 8.63899 10.8484 8.15741 12.1361 8.15741C13.4238 8.15741 14.5163 8.63899 15.4136 9.60216C16.3108 10.5653 16.7594 11.7381 16.7594 13.1204C16.7594 14.5027 16.3108 15.6754 15.4136 16.6386C14.5163 17.6017 13.4238 18.0833 12.1361 18.0833ZM0.577912 13.7407C0.41417 13.7407 0.276916 13.6812 0.16615 13.5621C0.0553832 13.4431 0 13.2956 0 13.1195C0 12.9435 0.0553832 12.7963 0.16615 12.6778C0.276916 12.5593 0.41417 12.5 0.577912 12.5H3.46747C3.63121 12.5 3.76847 12.5595 3.87923 12.6786C3.99 12.7977 4.04538 12.9452 4.04538 13.1212C4.04538 13.2972 3.99 13.4445 3.87923 13.563C3.76847 13.6815 3.63121 13.7407 3.46747 13.7407H0.577912ZM20.8048 13.7407C20.6411 13.7407 20.5038 13.6812 20.3931 13.5621C20.2823 13.4431 20.2269 13.2956 20.2269 13.1195C20.2269 12.9435 20.2823 12.7963 20.3931 12.6778C20.5038 12.5593 20.6411 12.5 20.8048 12.5H23.6944C23.8581 12.5 23.9954 12.5595 24.1061 12.6786C24.2169 12.7977 24.2723 12.9452 24.2723 13.1212C24.2723 13.2972 24.2169 13.4445 24.1061 13.563C23.9954 13.6815 23.8581 13.7407 23.6944 13.7407H20.8048ZM12.1354 4.43518C11.9714 4.43518 11.8342 4.37573 11.7238 4.25683C11.6134 4.13792 11.5582 3.99058 11.5582 3.81481V0.712961C11.5582 0.537189 11.6137 0.389851 11.7246 0.270947C11.8355 0.152042 11.9729 0.0925903 12.1369 0.0925903C12.3009 0.0925903 12.4381 0.152042 12.5485 0.270947C12.6589 0.389851 12.7141 0.537189 12.7141 0.712961V3.81481C12.7141 3.99058 12.6586 4.13792 12.5477 4.25683C12.4368 4.37573 12.2993 4.43518 12.1354 4.43518ZM12.1354 26.1481C11.9714 26.1481 11.8342 26.0887 11.7238 25.9698C11.6134 25.8509 11.5582 25.7035 11.5582 25.5278V22.4259C11.5582 22.2502 11.6137 22.1028 11.7246 21.9839C11.8355 21.865 11.9729 21.8056 12.1369 21.8056C12.3009 21.8056 12.4381 21.865 12.5485 21.9839C12.6589 22.1028 12.7141 22.2502 12.7141 22.4259V25.5278C12.7141 25.7035 12.6586 25.8509 12.5477 25.9698C12.4368 26.0887 12.2993 26.1481 12.1354 26.1481ZM5.61906 6.95485L3.95424 5.22259C3.84163 5.10646 3.78643 4.96408 3.78864 4.79546C3.79088 4.62685 3.84833 4.47414 3.96101 4.33735C4.08393 4.20056 4.22023 4.13216 4.36991 4.13216C4.51957 4.13216 4.6559 4.20056 4.77889 4.33735L6.41482 6.10063C6.53782 6.23744 6.59932 6.38379 6.59932 6.53967C6.59932 6.69556 6.54153 6.84191 6.42594 6.9787C6.31036 7.11549 6.17885 7.17872 6.0314 7.16838C5.88396 7.15804 5.74651 7.08686 5.61906 6.95485ZM19.4934 21.9034L17.8575 20.1401C17.7345 20.0033 17.673 19.8558 17.673 19.6975C17.673 19.5392 17.7345 19.3941 17.8575 19.262C17.9582 19.1252 18.0842 19.062 18.2353 19.0724C18.3865 19.0827 18.5258 19.1539 18.6532 19.2859L20.318 21.0182C20.4307 21.1343 20.4859 21.2767 20.4836 21.4453C20.4814 21.6139 20.424 21.7666 20.3113 21.9034C20.1884 22.0402 20.0521 22.1086 19.9024 22.1086C19.7527 22.1086 19.6164 22.0402 19.4934 21.9034ZM17.8575 6.99064C17.73 6.86657 17.6711 6.72539 17.6808 6.56712C17.6904 6.40884 17.7567 6.26129 17.8797 6.12448L19.4934 4.33735C19.6016 4.21646 19.7342 4.15721 19.8913 4.15958C20.0484 4.16198 20.1906 4.22366 20.318 4.34461C20.4455 4.47656 20.5092 4.62288 20.5092 4.78355C20.5092 4.94421 20.4455 5.09055 20.318 5.22259L18.6754 6.9787C18.548 7.11074 18.4117 7.17675 18.2665 7.17675C18.1212 7.17675 17.9849 7.11472 17.8575 6.99064ZM3.95424 21.9086C3.82681 21.7683 3.7631 21.6179 3.7631 21.4572C3.7631 21.2965 3.82681 21.1502 3.95424 21.0182L5.59684 19.262C5.72429 19.13 5.86173 19.064 6.00915 19.064C6.1566 19.064 6.29182 19.13 6.41482 19.262C6.52743 19.3702 6.57893 19.5054 6.56929 19.6677C6.55966 19.8299 6.50076 19.9794 6.3926 20.1163L4.77889 21.9034C4.6559 22.0402 4.51957 22.1074 4.36991 22.105C4.22023 22.1026 4.08167 22.0371 3.95424 21.9086Z"
                              fill="#99F8FF" />
                      </svg>

                    </div>


                  </div>

                  <div class="datosybarra">
                    <div class="piezas-buenasmalas-cont">
                      <div class="piezas-buenas">
                        <label class="">{{ piezasBuenasMannana }}</label>
                      </div>
                      <div class="piezas-malas">
                        <i class="icon-piezas-malas"></i>
                        <label class="">{{ piezasMalasMannana }}</label>
                      </div>
                    </div>
                    <div class="clearfix">
                      <!-- BARRA -->
                      <div class="barra-simple">
                        <div class="barra-simple-progreso" [ngStyle]="{'width': porcentajeMannana +'%'}"></div>
                      </div>
                    </div>
                    <div class="clearfix">
                      <label class="">{{ 'manana' | translate }}</label>
                    </div>
                  </div>

                  <!-- TOOLTIP -->
                  <div class="tooltiptext">
                    <div class="dia tooltipdiaheader">
                      <label>Día</label>
                      <div class="piezas-turnos-cantidades">
                        <label class=""><i class="icon-check"></i></label>
                        <label class="piezasmalas"><i class="icon-piezas-malas"></i></label>
                      </div>
                    </div>
                    <div *ngFor="let row of dataPiezasTurnos[0]; let i = index">
                      <div class="dia" *ngIf="i > 0">
                        <label class="">{{ dataPiezasTurnos[0][i] }}</label>
                        <div class="piezas-turnos-cantidades">
                          <label class="">{{ dataPiezasTurnos[1][i] }}</label>
                          <label *ngIf="dataPiezasTurnos[2][i]  > 0" class="piezasmalas">{{ dataPiezasTurnos[2][i] }}</label>
                          <label *ngIf="dataPiezasTurnos[2][i]  <= 0" class="piezascero">-</label>
                        </div>
                      </div>
                    </div>
                    <div class="dia total" *ngIf="dataPiezasTurnos[0]">
                      <label>{{ 'total' | translate }}</label>
                      <div class="piezas-turnos-cantidades">
                        <label class="">{{ piezasBuenasMannana }}</label>
                        <label class="piezasmalas">{{ piezasMalasMannana }}</label>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
              <!-- TARDE -->
              <div class="tarde bloque-turno celda-tooltip-externo order-3">
                <div class="inner-bloques-turnos tooltip-consumibles-contenido">
                  <div class="cont-icono">

                    <div class="cont-icono-circular">

                      <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_225_2114" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="31" height="31">
                          <rect x="0.861328" y="0.231476" width="29.7778" height="29.7778" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_225_2114)">
                          <path d="M22.8023 11.3812L21.9877 10.4888L23.9755 8.36044L24.7902 9.23852L22.8023 11.3812ZM5 23.4259V22.1852H26.871V23.4259H5ZM15.3599 8.20299V5.24429H16.5111V8.20299H15.3599ZM9.06873 11.3669L7.09412 9.22422L7.90876 8.34615L9.89663 10.4888L9.06873 11.3669ZM10.6692 16.6018H21.2018C20.7606 15.4852 20.0662 14.5856 19.1187 13.9032C18.1713 13.2208 17.1102 12.8796 15.9355 12.8796C14.7608 12.8796 13.6997 13.2208 12.7523 13.9032C11.8048 14.5856 11.1105 15.4852 10.6692 16.6018ZM9.16168 17.8426C9.42732 16.0435 10.198 14.5598 11.4738 13.3914C12.7497 12.2231 14.2369 11.6389 15.9355 11.6389C17.6341 11.6389 19.1214 12.2231 20.3972 13.3914C21.673 14.5598 22.4437 16.0435 22.7093 17.8426H9.16168Z" fill="#D9E497" />
                        </g>
                      </svg>


                    </div>


                  </div>

                  <div class="datosybarra">
                    <div class="piezas-buenasmalas-cont">
                      <div class="piezas-buenas">
                        <label class="">{{ piezasBuenasTarde }}</label>
                      </div>
                      <div class="piezas-malas">
                        <i class="icon-piezas-malas"></i>
                        <label class="">{{ piezasMalasTarde }}</label>
                      </div>
                    </div>
                    <div class="clearfix">
                      <!-- BARRA -->
                      <div class="barra-simple">
                        <div class="barra-simple-progreso" [ngStyle]="{'width': porcentajeTarde +'%'}"></div>
                      </div>
                    </div>
                    <div class="clearfix">
                      <label class="">{{ 'tarde' | translate }}</label>
                    </div>
                  </div>
                  <!-- TOOLTIP -->
                  <div class="tooltiptext">

                    <div class="dia tooltipdiaheader">
                      <label>Día</label>
                      <div class="piezas-turnos-cantidades">
                        <label class=""><i class="icon-check"></i></label>
                        <label class="piezasmalas"><i class="icon-piezas-malas"></i></label>
                      </div>
                    </div>

                    <div *ngFor="let row of dataPiezasTurnos[0]; let i = index">
                      <div class="dia" *ngIf="i > 0">
                        <label>{{ dataPiezasTurnos[0][i] }}</label>
                        <div class="piezas-turnos-cantidades">
                          <label class="">{{ dataPiezasTurnos[3][i] }}</label>
                          <label *ngIf="dataPiezasTurnos[4][i]  > 0" class="piezasmalas">{{ dataPiezasTurnos[4][i] }}</label>
                          <label *ngIf="dataPiezasTurnos[4][i]  <= 0" class="piezascero">-</label>
                        </div>
                      </div>
                    </div>
                    <div class="dia total" *ngIf="dataPiezasTurnos[0]">
                      <label class="">{{ 'total' | translate }}</label>
                      <div class="piezas-turnos-cantidades">
                        <label class="">{{ piezasBuenasTarde }}</label>
                        <label class="piezasmalas">{{ piezasMalasTarde }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- NOCHE -->
              <div class="noche bloque-turno celda-tooltip-externo" [ngClass]="turnoNochePrimero == true ? 'order-1': 'order-4'">
                <div class="inner-bloques-turnos  tooltip-consumibles-contenido">
                  <div class="cont-icono">

                    <div class="cont-icono-circular">

                      <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_225_2141" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="31" height="31">
                          <rect x="0.861328" y="0.231476" width="29.7778" height="29.7778" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_225_2141)">
                          <path d="M16.2466 25.0463C13.6781 25.0463 11.4949 24.0813 9.69694 22.1512C7.89898 20.2212 7 17.8775 7 15.1203C7 12.607 7.76314 10.4278 9.28943 8.58258C10.8157 6.73739 12.705 5.64777 14.9574 5.31372C15.0197 5.31372 15.0808 5.31611 15.1408 5.32089C15.2008 5.32564 15.2597 5.3328 15.3175 5.34235C14.9278 5.92614 14.6192 6.57554 14.3917 7.29056C14.1643 8.00558 14.0505 8.7544 14.0505 9.53702C14.0505 11.7428 14.7697 13.6177 16.2081 15.1617C17.6464 16.7057 19.393 17.4778 21.4478 17.4778C22.1813 17.4778 22.88 17.3557 23.5438 17.1115C24.2077 16.8673 24.8041 16.536 25.3331 16.1177C25.342 16.1797 25.3487 16.243 25.3532 16.3074C25.3576 16.3718 25.3598 16.4374 25.3598 16.5042C25.0635 18.9221 24.0558 20.9502 22.3369 22.5886C20.618 24.2271 18.5879 25.0463 16.2466 25.0463ZM16.2466 23.8055C17.9418 23.8055 19.4637 23.3041 20.8121 22.3011C22.1606 21.2982 23.143 19.9903 23.7595 18.3773C23.3742 18.4807 22.9889 18.5634 22.6036 18.6254C22.2184 18.6875 21.8331 18.7185 21.4478 18.7185C19.0784 18.7185 17.0605 17.8241 15.3942 16.0354C13.7279 14.2467 12.8947 12.0805 12.8947 9.53702C12.8947 9.12344 12.9236 8.70986 12.9814 8.29628C13.0392 7.88269 13.1163 7.46911 13.2126 7.05553C11.71 7.71726 10.4916 8.77189 9.55729 10.2194C8.623 11.667 8.15585 13.3006 8.15585 15.1203C8.15585 17.5191 8.94566 19.5663 10.5253 21.262C12.1049 22.9577 14.012 23.8055 16.2466 23.8055Z" fill="#1D7076" />
                        </g>
                      </svg>


                    </div>


                  </div>

                  <div class="datosybarra">
                    <div class="piezas-buenasmalas-cont">
                      <div class="piezas-buenas">
                        <label class="">{{ piezasBuenasNoche }}</label>
                      </div>
                      <div class="piezas-malas">
                        <i class="icon-piezas-malas"></i>
                        <label class="">{{ piezasMalasNoche }}</label>
                      </div>
                    </div>
                    <div class="clearfix">
                      <!-- BARRA -->
                      <div class="barra-simple">
                        <div class="barra-simple-progreso" [ngStyle]="{'width': porcentajeNoche +'%'}"></div>
                      </div>
                    </div>
                    <div class="clearfix">
                      <label class="">{{ 'noche' | translate }}</label>
                    </div>
                  </div>
                  <!-- TOOLTIP -->
                  <div class="tooltiptext">

                    <div class="dia tooltipdiaheader">
                      <label>Día</label>
                      <div class="piezas-turnos-cantidades">
                        <label class=""><i class="icon-check"></i></label>
                        <label class="piezasmalas"><i class="icon-piezas-malas"></i></label>
                      </div>
                    </div>

                    <div *ngFor="let row of dataPiezasTurnos[0]; let i = index">
                      <div class="dia" *ngIf="i > 0">
                        <label class="">{{ dataPiezasTurnos[0][i] }}</label>
                        <div class="piezas-turnos-cantidades">
                          <label class="">{{ dataPiezasTurnos[5][i] }}</label>
                          <label *ngIf="dataPiezasTurnos[6][i]  > 0" class="piezasmalas">{{ dataPiezasTurnos[6][i] }}</label>
                          <label *ngIf="dataPiezasTurnos[6][i]  <= 0" class="piezascero">-</label>
                        </div>
                      </div>
                    </div>
                    <div class="dia total" *ngIf="dataPiezasTurnos[0]">
                      <label class="">{{ 'total' | translate }}</label>
                      <div class="piezas-turnos-cantidades">
                        <label class="">{{ piezasBuenasNoche }}</label>
                        <label class="piezasmalas">{{ piezasMalasNoche }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="separador order-5"></div>

              <!-- TOTAL -->
              <div class="total bloque-turno celda-tooltip-externo order-6">
                <div class="inner-bloques-turnos  tooltip-consumibles-contenido">
                  <div class="cont-icono">

                    <div class="cont-icono-circular">

                      <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_225_2165" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="31" height="31">
                          <rect x="0.861328" y="0.231476" width="29.7778" height="29.7778" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_225_2165)">
                          <path d="M23.4639 11.0786C23.8173 11.0786 24.095 11.1286 24.2969 11.2286C24.4988 11.3214 24.6502 11.45 24.7512 11.6143C24.8594 11.7786 24.9279 11.9714 24.9567 12.1929C24.9856 12.4071 25 12.6357 25 12.8786V19.2214C25 19.4714 24.9856 19.7036 24.9567 19.9179C24.9279 20.1321 24.863 20.3214 24.762 20.4857C24.6611 20.6429 24.5096 20.7679 24.3077 20.8607C24.1058 20.9536 23.8317 21 23.4856 21C23.1466 21 22.8762 20.9571 22.6743 20.8714C22.4724 20.7786 22.3173 20.6571 22.2091 20.5071C22.101 20.3571 22.0288 20.1786 21.9928 19.9714C21.9639 19.7643 21.9495 19.5429 21.9495 19.3071V17.4H18.25C17.8029 17.4 17.4351 17.3643 17.1466 17.2929C16.8582 17.2214 16.6274 17.1286 16.4543 17.0143C16.2885 16.8929 16.1695 16.7536 16.0974 16.5964C16.0325 16.4393 16 16.2786 16 16.1143C16 16.0286 16.0072 15.9429 16.0216 15.8571C16.0433 15.7714 16.0649 15.6857 16.0865 15.6L18.2716 8.07857C18.3438 7.81429 18.4123 7.55714 18.4772 7.30714C18.5493 7.05714 18.643 6.83571 18.7584 6.64286C18.881 6.45 19.0469 6.29643 19.256 6.18214C19.4651 6.06071 19.75 6 20.1106 6C20.3702 6 20.5829 6.03571 20.7488 6.10714C20.9219 6.17857 21.0589 6.275 21.1599 6.39643C21.2608 6.51071 21.3293 6.64643 21.3654 6.80357C21.4087 6.95357 21.4303 7.11429 21.4303 7.28571C21.4303 7.45714 21.4159 7.63214 21.387 7.81071C21.3582 7.98214 21.3221 8.14286 21.2788 8.29286C21.2428 8.44286 21.2031 8.57857 21.1599 8.7C21.1238 8.81429 21.0986 8.9 21.0841 8.95714C21.0841 8.95714 21.0625 9.03571 21.0192 9.19286C20.976 9.34286 20.9183 9.54286 20.8462 9.79286C20.774 10.0357 20.6947 10.3179 20.6082 10.6393C20.5216 10.9536 20.4315 11.275 20.3377 11.6036C20.1142 12.375 19.8654 13.25 19.5913 14.2286L19.6779 14.3143H21.9495V12.8571C21.9495 12.6143 21.9639 12.3857 21.9928 12.1714C22.0216 11.9571 22.0865 11.7714 22.1875 11.6143C22.2885 11.45 22.4399 11.3214 22.6418 11.2286C22.8438 11.1286 23.1178 11.0786 23.4639 11.0786Z" fill="#565656" />
                          <path d="M11.9024 6C12.7195 6 13.4353 6.11009 14.0499 6.33026C14.6717 6.54332 15.1887 6.84517 15.6009 7.2358C16.013 7.61932 16.3239 8.08097 16.5336 8.62074C16.7433 9.15341 16.8482 9.7429 16.8482 10.3892C16.8482 10.8153 16.7867 11.2095 16.6638 11.5717C16.5481 11.9339 16.3926 12.2642 16.1974 12.5625C16.0094 12.8608 15.7925 13.1307 15.5466 13.3722C15.3008 13.6136 15.0513 13.8267 14.7983 14.0114C14.1909 14.4517 13.5076 14.8068 12.7484 15.0767C12.4953 15.1761 12.2422 15.2969 11.9892 15.4389C11.7433 15.5739 11.5228 15.7337 11.3275 15.9183C11.1323 16.0959 10.9732 16.3054 10.8503 16.5469C10.7274 16.7812 10.6659 17.0511 10.6659 17.3565V18.017H14.4403C14.744 18.017 15.0477 18.0312 15.3514 18.0597C15.6551 18.0881 15.9299 18.152 16.1757 18.2514C16.4215 18.3509 16.6204 18.5 16.7722 18.6989C16.9241 18.8906 17 19.1534 17 19.4872C17 19.8281 16.9241 20.098 16.7722 20.2969C16.6204 20.4957 16.4215 20.6484 16.1757 20.755C15.9299 20.8615 15.6551 20.929 15.3514 20.9574C15.0477 20.9858 14.744 21 14.4403 21H9.03905C8.67751 21 8.37744 20.9432 8.13883 20.8295C7.90745 20.7088 7.72307 20.5597 7.58568 20.3821C7.4483 20.1974 7.35069 19.995 7.29284 19.7749C7.24223 19.5476 7.21692 19.3239 7.21692 19.1037V17.3991C7.21692 16.8523 7.3073 16.3409 7.48807 15.8651C7.67607 15.3821 7.93637 14.9453 8.26898 14.5547C8.60882 14.157 9.01012 13.8018 9.47289 13.4893C9.94288 13.1768 10.4635 12.9105 11.0347 12.6903C11.6059 12.4702 12.0615 12.2607 12.4013 12.0618C12.7411 11.8558 13.0014 11.657 13.1822 11.4652C13.3702 11.2663 13.4931 11.0675 13.551 10.8686C13.6088 10.6697 13.6377 10.4673 13.6377 10.2614C13.6377 9.89205 13.5727 9.60085 13.4425 9.38778C13.3196 9.17472 13.1641 9.01847 12.9761 8.91903C12.7954 8.8125 12.6038 8.74858 12.4013 8.72727C12.2061 8.69886 12.0398 8.68466 11.9024 8.68466C11.5409 8.68466 11.2516 8.73793 11.0347 8.84446C10.8178 8.94389 10.6515 9.07173 10.5358 9.22798C10.4273 9.38423 10.355 9.55824 10.3189 9.75C10.2899 9.93466 10.2755 10.1122 10.2755 10.2827C10.2755 10.5597 10.2213 10.7976 10.1128 10.9964C10.0043 11.1882 9.86696 11.3445 9.70065 11.4652C9.54158 11.5859 9.36443 11.6747 9.1692 11.7315C8.9812 11.7884 8.80766 11.8168 8.64859 11.8168C8.15691 11.8168 7.75922 11.6854 7.45553 11.4226C7.15184 11.1527 7 10.8082 7 10.3892C7 10.2045 7.02169 9.96662 7.06508 9.67543C7.10846 9.38423 7.19161 9.07528 7.31453 8.74858C7.43745 8.42188 7.61099 8.09517 7.83514 7.76847C8.05929 7.44176 8.35213 7.14702 8.71367 6.88423C9.0752 6.62145 9.51627 6.40838 10.0369 6.24503C10.5575 6.08168 11.1793 6 11.9024 6Z"
                                fill="#565656" />
                        </g>
                      </svg>


                    </div>

                  </div>

                  <div class="datosybarra">
                    <div class="piezas-buenasmalas-cont">
                      <div class="piezas-buenas">
                        <label class="">{{ roundPiezas(piezasBuenasMannana, piezasBuenasTarde, piezasBuenasNoche) }}</label>
                      </div>
                      <div class="piezas-malas">
                        <i class="icon-piezas-malas"></i>
                        <label class="">{{ roundPiezas(piezasMalasMannana, piezasMalasTarde, piezasMalasNoche) }}</label>
                      </div>
                    </div>
                    <div class="clearfix">
                      <!-- BARRA -->
                      <div class="barra-simple">
                        <div class="barra-simple-progreso" [ngStyle]="{'width': '100%'}"></div>
                      </div>
                    </div>
                    <div class="clearfix">
                      <label class="">{{ 'total' | translate }}</label>
                    </div>
                  </div>
                  <!-- TOOLTIP -->
                  <div class="tooltiptext">

                    <div class="dia tooltipdiaheader">
                      <label>Día</label>
                      <div class="piezas-turnos-cantidades">
                        <label class=""><i class="icon-check"></i></label>
                        <label class="piezasmalas"><i class="icon-piezas-malas"></i></label>
                      </div>
                    </div>


                    <div *ngFor="let row of dataPiezasTurnos[0]; let i = index">
                      <div class="dia" *ngIf="i > 0">
                        <label class="">{{ dataPiezasTurnos[0][i] }}</label>
                        <div class="piezas-turnos-cantidades">
                          <label class="">{{ roundPiezas(dataPiezasTurnos[1][i], dataPiezasTurnos[3][i], dataPiezasTurnos[5][i]) }}</label>
                          <label *ngIf="roundPiezas(dataPiezasTurnos[2][i], dataPiezasTurnos[4][i], dataPiezasTurnos[6][i])  > 0" class="piezasmalas">{{ roundPiezas(dataPiezasTurnos[2][i], dataPiezasTurnos[4][i], dataPiezasTurnos[6][i]) }}</label>
                          <label *ngIf="roundPiezas(dataPiezasTurnos[2][i], dataPiezasTurnos[4][i], dataPiezasTurnos[6][i])  <= 0" class="piezascero">-</label>
                        </div>
                      </div>
                    </div>
                    <div class="dia total" *ngIf="dataPiezasTurnos[0]">
                      <label class="">{{ 'total' | translate }}</label>
                      <div class="piezas-turnos-cantidades">
                        <label class="">{{ roundPiezas(piezasBuenasMannana, piezasBuenasTarde, piezasBuenasNoche) }}</label>
                        <label class="piezasmalas">{{ roundPiezas(piezasMalasMannana, piezasMalasTarde, piezasMalasNoche) }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix">
            <div id="chartBar_turnos" style="height: 240px;"></div>
          </div>
        </div>

        <div [ngClass]="{'d-none': !this.sinPiezasTurnos}">
          <div id="chartAreaHorasDia_Estados"></div>
        </div>

      </div>
      <div class="clearfix cont-piezasturno-vacio" *ngIf="sinPiezasTurnos && this.sinEstados" style="height: 300px;position: relative;display: flex;align-items: center;">
        <img src="../../../assets/img/barras-turnos-vacio.png" style="height: auto; margin: 0 auto;" />
        <div class="sindatos-x-cont">
          <img src="../../../assets/img/equis-vacio.png" style="height: auto; margin: 0 auto;" />
          <label>{{ 'sinDatos' | translate}}</label>
        </div>
      </div>
      <div *ngIf="loadingHorasDia_Estados" class="k-i-loading"></div>
    </div>
  </div>
</div>
<!--LINEA 2.2-->
<div class="row" [ngClass]="{'d-none': !this.tieneSubEstados_personalizados}">
  <!--Resumen Semana-->
  <div class="col-md-6">
    <div class="card">
      <div class="card-header">
        <h3>
          <label ID="lResumenSemana_subEstados" CssClass="">{{ 'resumen' | translate }} ({{ 'subestados' | translate }})</label>
        </h3>
        <div class="plegarpanel"></div>
      </div>
      <div class="card-body">
        <div class="row" [ngClass]="{'d-none': this.sinSubestados}" id="chartDonutResumenSemana_subEstados"></div>
        <div class="clearfix cont-donut-vacio" *ngIf="sinSubestados" style="height: 300px;position: relative;display: flex;align-items: center;">
          <img class="float-left" src="../../../assets/img/donut-vacio.png" style="height: auto; margin: 0 auto; width: 60%; max-width: 275px;" />
          <div>
            <img class="float-left" src="../../../assets/img/equis-vacio.png" style="height: auto; margin: 0 auto; width: 60%; max-width: 275px;" />
            <label class="sindatos">{{ 'sinDatos' | translate}}</label>
          </div>
        </div>
      </div>
      <div *ngIf="loadingResumenSemana_subEstados" class="k-i-loading"></div>
    </div>
  </div>
  <!--Horas Dia-->
  <div class="col-md-6">
    <div class="card">
      <div class="card-header">
        <h3>
          <label ID="lHorasDia_subEstados" CssClass="">{{ 'horasDia' | translate }} ({{ 'subestados' | translate }})</label>
        </h3>
        <div class="plegarpanel"></div>
      </div>
      <div class="card-body">
        <div id="chartAreaHorasDia_subEstados"></div>
      </div>
      <div *ngIf="loadingHorasDia_subEstados" class="k-i-loading"></div>
    </div>
  </div>
</div>

<!--LINEA 3-->
<div class="row">
  <!--OEE-->
  <div class="col-md-4 col-lg-3 col-xl-3">
    <div class="card">
      <div class="card-header">
        <h3>
          <label ID="lOEE" CssClass="">{{ 'oee' | translate }}</label>
        </h3>
        <div class="plegarpanel"></div>
      </div>
      <div [ngClass]="{'d-none': this.sinEstados}" class="card-body">
        <div class="row">
          <!--OEE-->
          <div class="col-lg-6 col-xxl-12" style="padding: 0 5px">
            <div id="chartDonutOEE_InformeRendimiento" style="height: 140px"></div>
            <p class="oee-donut-label">{{ 'oee' | translate }}</p>
          </div>
          <!--Disponibilidad-->
          <div class="col-lg-6 col-xxl-4" style="padding: 0 5px">
            <div id="chartDonutOEEDisponibilidad_InformeRendimiento" style="height: 140px"></div>
            <p class="oee-donut-label">{{ 'disponibilidad' | translate }}</p>
          </div>
          <!--Rendimiento-->
          <div class="col-lg-6 col-xxl-4" style="padding: 0 5px">
            <div id="chartDonutOEERendimiento_InformeRendimiento" style="height: 140px"></div>
            <p class="oee-donut-label">{{ 'rendimiento' | translate }}</p>
          </div>
          <!--Calidad-->
          <div class="col-lg-6 col-xxl-4" style="padding: 0 5px">
            <div id="chartDonutOEECalidad_InformeRendimiento" style="height: 140px"></div>
            <p class="oee-donut-label">{{ 'calidad' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="clearfix cont-donut-vacio" *ngIf="sinEstados" style="height: 300px;position: relative;display: flex;align-items: center;">
        <img class="float-left" src="../../../assets/img/oee-vacio.png" style="height: auto; margin: 0 auto; " />
        <div class="sindatos-x-cont">
          <img class="float-left" src="../../../assets/img/equis-vacio.png" style="height: auto; margin: 0 auto;" />
          <label class="sindatos">{{ 'sinDatos' | translate}}</label>
        </div>
      </div>
      <div *ngIf="loadingOeeHoras" class="k-i-loading"></div>
    </div>
  </div>
  <div class="col-md-8 col-lg-9 col-xl-9">
    <!--Horas-->
    <div class="card">
      <div class="card-header">
        <h3>
          <label ID="lHoras" CssClass="">{{ 'horas' | translate }}</label>
        </h3>
        <div class="plegarpanel"></div>
      </div>
      <div [ngClass]="{'d-none': this.sinEstados}" class="card-body">
        <div id="chartBarHoras_InformeRendimiento"></div>
      </div>
      <div class="clearfix cont-donut-vacio" *ngIf="sinEstados" style="height: 300px;position: relative;display: flex;align-items: center;">
        <img src="../../../assets/img/oee-barras-vacio.png" style="height: 100%; margin: 0 auto; width: 100%; margin: 10px;" />
        <div class="sindatos-x-cont sindatos-x-cont-horas ">
          <img src="../../../assets/img/equis-vacio.png" style="height: auto; margin: 0 auto;" />
          <label class="sindatos">{{ 'sinDatos' | translate}}</label>
        </div>
      </div>
      <div *ngIf="loadingOeeHoras" class="k-i-loading"></div>
    </div>
  </div>
</div>

<!--LINEA 4-->
<div class="row">
  <!--Paradas-->
  <div class="col-md-4">
    <div class="card">
      <div class="card-header">
        <h3>
          <label CssClass="">{{ 'perdidas' | translate }}</label>
        </h3>
        <!-- AGRUPAR POR: -->
        <div id="checkboxGrupos" class="position-absolute clearfix" style="top: 8px; right: 45px;">
          <!-- Grupo -->
          <div class="float-left mr-2">
            <input type="radio" name="groupData" class="k-radio" (change)="checkboxChange(2)" [checked]="agrupado == 2" kendoRadioButton>
            <label for="groupData"> {{ 'grupos' | translate }}</label><br>
          </div>
          <!-- Perdida -->
          <div class="float-left mr-2">
            <input type="radio" name="groupData" class="k-radio" (change)="checkboxChange(1)" [checked]="agrupado == 1" kendoRadioButton>
            <label for="groupData"> {{ 'perdidas' | translate }}</label><br>
          </div>
          <!-- Sub-perdida -->
          <div class="float-left mr-2">
            <input type="radio" name="groupData" class="k-radio" (change)="checkboxChange(0)" [checked]="agrupado == 0" kendoRadioButton>
            <label for="groupData"> {{ 'subperdidas' | translate }}</label><br>
          </div>
        </div>
        <div class="plegarpanel"></div>
      </div>
      <div class="card-body">
        <div class="row" [ngClass]="{'d-none': this.sinPerdidas}" id="chartDonutParadas" style="height: 300px;"></div>
        <div class="clearfix cont-donut-vacio" *ngIf="sinPerdidas" style="height: 300px;position: relative;display: flex;align-items: center;">
          <img class="float-left" src="../../../assets/img/donut-vacio.png" style="height: auto; margin: 0 auto; width: 60%; max-width: 275px;" />
          <div>
            <label class="sindatos">{{ 'sinDatos' | translate}}</label>
          </div>
        </div>
      </div>
      <div *ngIf="loadingPerdidas" class="k-i-loading"></div>
    </div>
  </div>
  <!--Mantenimientos-->
  <div class="col-md-4">
    <div class="card">
      <div class="card-header">
        <h3>
          <label CssClass="">{{ 'mantenimientos' | translate }}</label>
        </h3>
        <div class="plegarpanel"></div>
      </div>
      <div class="card-body">
        <div class="row" [ngClass]="{'d-none': this.sinMantenimientos}" id="chartDonutMantenimientos" style="height: 300px;"></div>
        <div class="clearfix cont-donut-vacio" *ngIf="sinMantenimientos" style="height: 300px;position: relative;display: flex;align-items: center;">
          <img class="float-left" src="../../../assets/img/donut-vacio.png" style="height: auto; margin: 0 auto; width: 60%; max-width: 275px;" />
          <div>
            <label class="sindatos">{{ 'sinDatos' | translate}}</label>
          </div>
        </div>
      </div>
      <div *ngIf="loadingPerdidas" class="k-i-loading"></div>
    </div>
  </div>
  <!--Alarmas-->
  <div class="col-md-4">
    <div class="card">
      <div class="card-header">
        <h3>
          <label CssClass="">{{ 'alarmas' | translate }}</label>
        </h3>
        <div class="plegarpanel"></div>
      </div>
      <div class="card-body">
        <div class="row" [ngClass]="{'d-none': this.sinAlarmas}" id="chartDonutAlarmas" style="height: 300px;"></div>
        <div class="clearfix cont-donut-vacio" *ngIf="sinAlarmas" style="height: 300px;position: relative;display: flex;align-items: center;">
          <img class="float-left" src="../../../assets/img/donut-vacio.png" style="height: auto; margin: 0 auto; width: 60%; max-width: 275px;" />
          <div>
            <label class="sindatos">{{ 'sinDatos' | translate}}</label>
          </div>
        </div>
      </div>
      <div *ngIf="loadingPerdidas" class="k-i-loading"></div>
    </div>
  </div>
</div>